import React, {useEffect, useMemo, useState} from 'react'
import useTranslate from "../../../../modules/local/useTranslate";
import {NullAsDefault} from 'views/Shared'
import {godwords_getWordsOfGod_Api, godwordsSchema} from "../../../../apis/godwords";
import {API_ROOT_URL} from "../../../../envs/_current/config";
import {LookupTagsPicker} from "../../../AppLocals/custom/TagsPicker";
import {createListTransform} from "../../../../apis/utils/createListTransform";
import {baseItemSchema} from "../../../../apis/schema";
import {GodWordItem} from "../components/GodWordItem";
import {useGodWords} from "../functions/useGodWords";
import {useLocation} from "react-use";
import _ from "lodash";
import usePaginationHelper, {createPagerKey} from "../../hooks/usePaginationHelper";
import {NoneStickyMeta} from "../../EntityList";
import {Input} from "antd";
import {SelectEntityItem} from "../../../../components/SelectEntityItem";
import {TagCloudWoGHashTags} from "../components/TagCloudWoGHashTags";
import Toggle from "../../../../components/Toggle";
import {useRouteSearchParam} from "../../../../envs/_current/history";

export const CategoryItems = ({
                                  handleDisplayById,
                                  filter_actions = {
                                      sortBy: 'sort-by',
                                      keyword: 'keyword',
                                      hashtags: 'hashtags',
                                  }
                              }) => {
    const t = useTranslate()
    const [hashtags, setHashtags] = useState([]);
    const [keyword, setKeyword] = useState("");
    const location = useLocation()
    const [refreshToken, setRefreshToken] = useState()

    const sortBy = useRouteSearchParam(filter_actions.sortBy)
    const wogHashTags = useRouteSearchParam("wog_hashtags")

    useEffect(() => {
        if (wogHashTags) {
            const hashtags = decodeURIComponent(wogHashTags);
            setHashtags([hashtags]);
        }
    }, [wogHashTags])

    const refresh_deps = useMemo(
        () => [
            hashtags,
            keyword,
            refreshToken,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [location.state, hashtags, keyword, refreshToken]
    )

    const onRefresh = () => {
        setRefreshToken(Date.now())
    }

    const {
        modal,
        handleAction,
        onVote,
        onDevote
    } = useGodWords({
        notifyListeners: {
            onDeleted: (result) => {
                onRefresh()
            },
        },
    })

    const [pager_widget] = usePaginationHelper({
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onSortChange(sortBy)
            onFilterChange({hashtags, keyword});
        },
        pagerInfo: {
            PaginationMeta: NoneStickyMeta,
            apiInfo: godwords_getWordsOfGod_Api,
            renderItem: ogItem => {
                return (
                    <SelectEntityItem
                        item={ogItem}
                        schema={godwordsSchema}>
                        {(item) => (
                            <GodWordItem item={item} {...{handleDisplayById, handleAction, onVote, onDevote}} />
                        )}
                    </SelectEntityItem>
                )
            },
            renderWrap: (child) => (
                <div className="flex flex-col gap-4">
                    {child}
                </div>
            )
        },
        withValues: () => ({
            hashtags, keyword
        }),
        withKey: createPagerKey(refresh_deps),
        dependencies: [hashtags, keyword, refreshToken],
        filter_params: {
            hashtags, keyword
        },
        SortByWidget: NullAsDefault,
        renderSearchBar: NullAsDefault,
        isToggleDefault: true,
        query_params: filter_actions,
        renderFilter: NullAsDefault,
        AdvancedFilter: NullAsDefault,
        noHeader: true,
        renderSortBy: NullAsDefault,
    })

    return (
        <div className="flex flex-col gap-3">
            <Input.Search
                defaultValue={keyword}
                onSearch={(value) => {
                    setKeyword(value)
                }}
                allowClear={true}
                className="input-search"
                placeholder={t('search')}
            />
            <div className="w-full flex flex-col gap-1">
                <span className="font-medium text-xs text-color-500 uppercase tracking-wide">
                    {t('choose topic')}
                </span>
                <LookupTagsPicker
                    value={hashtags}
                    apiInfo={{
                        root: API_ROOT_URL,
                        path: '/lookup/god_word_hashtags/gets',
                        method: 'GET',
                        schema: baseItemSchema,
                        transform: createListTransform(baseItemSchema),
                        paramFields: ['keyword'],
                        fields: ['keyword'],
                    }}
                    onChange={(e) => {
                        setHashtags(e?.target?.value)
                    }}
                />
                <Toggle defaultValue={false}>
                    {(isToggle, toggle) => (
                        <React.Fragment>
                            <div
                                onClick={toggle}
                                className="mr-1 text-right text-xs text-color-400 hover:text-color-100 italic cursor-pointer">
                                {`... ${isToggle ? t('see less') : t('see more')}`}
                            </div>
                            {isToggle && (
                                <TagCloudWoGHashTags setHashtags={setHashtags}/>
                            )}
                        </React.Fragment>
                    )}
                </Toggle>
            </div>
            {pager_widget}
            {modal}
        </div>
    )
}

